import { t } from "@lingui/macro";
import React from "react";
import { Path } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const FlagOutlineIcon = (props: IconProps) => (
  <Icon viewBox="0 0 16 16" fill="none" title={t`Flag Outline`} {...props}>
    <Path
      fill="currentColor"
      d="M12.462.446a.75.75 0 0 1 1.227.345l2.03 7a.75.75 0 0 1-.131.674l-.07.077-.003.003-.006.005-.016.015-.053.048a7.268 7.268 0 0 1-.88.647 7.122 7.122 0 0 1-2.473.978c-1.238.226-2.148-.115-2.95-.346-.784-.226-1.63-.418-2.997-.156a.75.75 0 0 1-.282-1.473c1.68-.321 2.78-.076 3.695.188.898.259 1.442.46 2.264.31a5.63 5.63 0 0 0 2.323-1.03L12.549 2.25c-.558.37-1.36.828-2.366 1.203-1.387.517-2.522.144-3.46-.175-.957-.325-1.73-.599-2.736-.379-.607.133-.928.386-1.091.565-.04.043-.073.085-.099.122l2.974 11.221a.75.75 0 0 1-1.45.385l-3.046-11.5a.753.753 0 0 1 .006-.411L2 3.5l-.717-.22v-.003l.002-.004.003-.01.008-.023.024-.064c.02-.05.05-.114.088-.188.079-.148.2-.338.381-.536.37-.404.964-.818 1.88-1.019 1.469-.321 2.626.114 3.538.424.93.316 1.606.506 2.453.19A10.251 10.251 0 0 0 11.75.982a7.986 7.986 0 0 0 .678-.506l.03-.025.005-.005Z"
    />
  </Icon>
);
